import React from 'react';

import { useFormikContext } from 'formik';

import { useManagementPackContext } from './ManagementPackContext';
import { SNAPSHOT_COMPLETED } from './managementPackUtils';

import Modal from 'CommonComponents/Modal';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

/**
 * Why the pack cannot be exported yet, or null when it can.
 */
export const exportBlocker = ({ activePack, preview, options }) => {
    if (!activePack) {
        return $t('Generate the pack before exporting it.');
    }

    if (activePack.snapshotStatus !== SNAPSHOT_COMPLETED) {
        return $t('The pack can be exported once its data has been captured.');
    }

    if (preview?.overCap) {
        return $t('This pack has too many slides to export. Turn off some sections to bring it under the limit of {{max}}.', { max: options.maxSlides });
    }

    return null;
};

/**
 * Export the pack as .pptx. An issued pack exports final; a draft exports with
 * the watermark its options ask for. Issuing is a separate action.
 */
const ExportPackModal = ({ modal }) => {
    const { values } = useFormikContext();
    const { activePack, preview, exportPack } = useManagementPackContext();

    const download = () => {
        modal.hide();
        exportPack();
    };

    const watermarked = !activePack?.isIssued && values.options.watermark_drafts;

    return (
        <Modal modal={modal}>
            <ModalHeader title={$t('Export management pack')} close={modal.hide} dark />
            <div className="tw-flex tw-flex-col tw-gap-4 tw-text-sm tw-text-charcoal">
                <p className="tw-m-0">
                    {$t('Download the pack as an editable PowerPoint file.')}{' '}
                    {preview?.slideCount ? $t('{{count}} slides.', { count: preview.slideCount }) : ''}
                </p>

                <p className="tw-m-0 tw-text-charcoal-75">
                    {activePack?.isIssued
                        ? $t('This pack is issued, so the export is final.')
                        : $t('This is a draft export. Issue the pack to export a final copy.')}
                </p>

                <p className="tw-m-0 tw-text-charcoal-75">
                    {watermarked ? $t('This export will carry a DRAFT watermark.') : $t('This export will not carry a watermark.')}
                </p>
            </div>
            <ModalFooter
                handleSubmit={download}
                onCancel={modal.hide}
                submitButtonVariant="primary"
                primaryButtonText={$t('Download .pptx')}
                cancelButtonText={$t('Cancel')}
            />
        </Modal>
    );
};

export default ExportPackModal;
